import { motion } from "framer-motion";
import { JOURNEY_STEPS } from "@/lib/data";

const LearningJourney = () => (
    <section data-testid="journey-section" className="sxe-section relative overflow-hidden">
        <div className="sxe-container">
            <div className="max-w-3xl">
                <div className="overline"><span className="dot" /> Learning Journey</div>
                <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-medium tracking-tighter leading-[1.05] text-white mt-5">
                    <span className="text-gradient">Diagnose. Design. Deliver.</span> Demonstrate.
                </h2>
                <p className="text-[#B0A3C4] text-lg leading-relaxed mt-5">
                    A repeatable engagement model that scales from a single team to enterprise-wide transformation.
                </p>
            </div>

            <div className="relative mt-16">
                <div className="hidden lg:block absolute left-0 right-0 top-14 h-px bg-gradient-to-r from-transparent via-[#C266FF]/40 to-transparent" />
                <div className="grid lg:grid-cols-4 gap-5 relative">
                    {JOURNEY_STEPS.map((s, i) => (
                        <motion.div
                            key={s.step}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-60px" }}
                            transition={{ duration: 0.6, delay: i * 0.08 }}
                            className="sxe-card p-7 relative"
                            data-testid={`journey-step-${i}`}
                        >
                            <div className="hidden lg:flex absolute -top-4 left-7 w-8 h-8 rounded-full bg-[#0a041a] border border-[#C266FF]/40 items-center justify-center">
                                <span className="font-mono text-[11px] text-[#E9CCFF]">{i + 1}</span>
                            </div>
                            <div className="text-[#75668C] font-mono text-sm">STEP {s.step}</div>
                            <h3 className="font-display text-white text-2xl font-medium tracking-tight mt-2">{s.title}</h3>
                            <p className="text-[#B0A3C4] text-[14px] leading-relaxed mt-3">{s.desc}</p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </div>
    </section>
);

export default LearningJourney;
